import { render, staticRenderFns } from "./live-subtitle.vue?vue&type=template&id=2f3d6a10&scoped=true&"
import script from "./live-subtitle.vue?vue&type=script&lang=js&"
export * from "./live-subtitle.vue?vue&type=script&lang=js&"
import style0 from "./live-subtitle.vue?vue&type=style&index=0&id=2f3d6a10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3d6a10",
  null
  
)

export default component.exports